import { useEffect, useState } from 'react'

import styles from './textArea.module.scss'

type Props = {
  value?: string
  className?: string
  header?: string
  id?: string
  placeholder?: string
  disabled?: boolean
  onChange?: (v: string, e: React.ChangeEvent<HTMLTextAreaElement>) => void
  noResize?: boolean
  maxCharacters?: number
}

const TextArea = ({
  value,
  className,
  onChange,
  header,
  id,
  placeholder,
  disabled,
  noResize = false,
  maxCharacters,
}: Props) => {
  const [internalValue, setInternalValue] = useState(value || '')

  useEffect(() => {
    if (value === internalValue) return

    setInternalValue(value || '')
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setInternalValue(e.target.value)

    if (onChange) onChange(e.target.value, e)
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {header && (
        <label className={styles.header} htmlFor={id}>
          {header}
        </label>
      )}
      <textarea
        className={`${styles.textarea} ${noResize ? styles.noResize : ''}`}
        id={id}
        value={internalValue}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
      />
      {maxCharacters && (
        <div
          className={`${styles.maxCharacters} ${maxCharacters && internalValue.length > maxCharacters ? styles.warning : ''}`}>
          {internalValue.length} / {maxCharacters}
        </div>
      )}
    </div>
  )
}

export default TextArea
